var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMinimise(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 21,
    viewBox: "0 0 28 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.7038 0H20.4575C19.1025 0 18.0001 1.08695 18.0001 2.4247C18.0001 3.76076 19.1025 4.84776 20.4575 4.84776H24.7038C26.0588 4.84776 27.1613 3.76076 27.1613 2.4247C27.1613 1.08695 26.0588 0 24.7038 0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2464 15.7762H2.45743C1.10242 15.7762 0 16.8632 0 18.2009C0 19.537 1.10242 20.624 2.45743 20.624H24.2464C25.6014 20.624 26.7038 19.537 26.7038 18.2009C26.7038 16.8632 25.6014 15.7762 24.2464 15.7762Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2463 7.88818H9.99994C8.64493 7.88818 7.54251 8.97518 7.54251 10.3129C7.54251 11.6489 8.64493 12.7359 9.99994 12.7359H24.2463C25.6013 12.7359 26.7037 11.6489 26.7037 10.3129C26.7037 8.97518 25.6013 7.88818 24.2463 7.88818Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinimise);
export default __webpack_public_path__ + "static/media/minimise.9535ae16.svg";
export { ForwardRef as ReactComponent };